import { useEffect, useContext, useState, useCallback } from 'react';
import { AuthContext } from '@/router/authContext';
import { useTranslation } from 'react-i18next';
import { ProForm } from '@ant-design/pro-components';
import { Button, Checkbox, Form, Input } from 'antd';
import PubCompone from '@/login/pubCompone';
import { getUserLocalStorage } from '@/utils/toolt';
import { useNavigate, useLocation } from 'react-router-dom';
import { REMEMBERPASS, USERINFO, PageEnum } from '@/enums/pageEnum';

const Login = () => {
  const checkCoche = getUserLocalStorage(REMEMBERPASS);
  const colckelUser = getUserLocalStorage(USERINFO);
  const { signin } = useContext(AuthContext);
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);
  const [logFaild, setLogFaild] = useState(false);
  const [checked, setChecked] = useState<boolean>(checkCoche);
  const [form] = Form.useForm();
  const keyDown = useCallback(
    (e: any) => {
      if (e.keyCode === 13) {
        form.submit();
      }
    },
    [form],
  );
  useEffect(() => {
    if (state && state?.token && state?.email) {
      form.setFieldsValue({ name: state?.email });
      return;
    }
    if (logFaild) {
      form.setFields([
        {
          name: 'password',
          errors: ['Incorrect user name or password.'],
        },
        {
          name: 'name',
          errors: ['Incorrect user name or password.'],
        },
      ]);
      return;
    }
    if (checkCoche && colckelUser && form && !loading) {
      form.setFieldsValue(colckelUser);
    }
  }, [checkCoche, colckelUser, form, state, loading, logFaild]);
  useEffect(() => {
    window.addEventListener('keydown', keyDown);
    return () => {
      window.removeEventListener('keydown', keyDown, false);
    };
  }, [keyDown]);
  return (
    <PubCompone title={t('logIn')}>
      <div className="pb-7">
        <h3 className="text-3xl font-bold text-opacity-85 pb-3">{t('logIn')}</h3>
        <p className="text-base font-medium text-opacity-85">{t('hint.loginHint')}</p>
      </div>
      <ProForm
        name="login"
        form={form}
        submitter={{
          render: (props) => {
            return [
              <Button
                type="primary"
                loading={loading}
                className="w-full !h-14 leading-[48px]"
                onClick={() => props.form?.submit?.()}
              >
                {t('signIn')}
              </Button>,
            ];
          },
        }}
        onFinish={async (value) => {
          setLoading(true);
          const path = new URL(window.location.href);
          const inviteToken = path.searchParams.get('token');
          const res = await signin({ ...value, inviteToken });
          setLoading(false);
          if (!res) {
            setLogFaild(true);
            return;
          }
          setLogFaild(false);
          localStorage.setItem(USERINFO, JSON.stringify({ name: value.name }));
          navigation(
            state && state.token
              ? `${PageEnum.JOIN_SUCCESS}?company=${state?.name}&code=${state?.id}`
              : `${PageEnum.CHOOSE_ORGAN}${window.location.search}`,
            { replace: true },
          );
        }}
      >
        <Form.Item
          name="name"
          label={t('email')}
          rules={[{ required: true, type: 'email' }]}
        >
          <Input className="h-14" placeholder={t('hint.nameVal')} />
        </Form.Item>
        <Form.Item name="password" label={t('password')} rules={[{ required: true }]}>
          <Input.Password className="h-14" placeholder={t('hint.passPlaceholder')} />
        </Form.Item>
        <div className="remember h-14 flex justify-between">
          <div>
            <Checkbox
              checked={checked}
              onChange={(e) => {
                setChecked(e.target.checked);
                localStorage.setItem(REMEMBERPASS, e.target.checked ? 'true' : 'false');
              }}
            >
              <span className="text-[#0000008c] dark:text-[#ffffff8c]">
                {t('rememberPassword')}
              </span>
            </Checkbox>
          </div>
          <div>
            <Button
              className="text-[#0000008c] dark:text-[#ffffff8c] border-0 pt-0 pr-0 shadow-none"
              onClick={(e) => {
                navigation(PageEnum.FORGET_PASS);
                e.stopPropagation();
              }}
            >
              {t('forgetPassword')}
            </Button>
          </div>
        </div>
      </ProForm>
    </PubCompone>
  );
};

export default Login;
